import { IRiskCategoryEditItem, RiskCategoryEditItem } from "./riskCategoryEditItem";

export interface IRiskCategoryEdit {
    item: IRiskCategoryEditItem;
}

export class RiskCategoryEdit implements IRiskCategoryEdit {
    item: RiskCategoryEditItem;

    constructor();
    constructor(obj: IRiskCategoryEdit);
    constructor(obj?: any) {
        this.item = new RiskCategoryEditItem(obj ? obj.item : null);
    }
}